'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _redux = require('redux');

var _createRenderer = require('./createRenderer');

var _createRenderer2 = _interopRequireDefault(_createRenderer);

var _isPromise = require('is-promise');

var _isPromise2 = _interopRequireDefault(_isPromise);

/**
 * Decorates all middlewares before passing them to the original implementation.
 *
 * This allows us to catch promises returned at any point during a dispatch. We
 * can then add those to the promise store for delaying the rendering of the
 * output in the universal renderer.
 */

exports['default'] = function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  // List of promises.
  var activePromises = [];

  // Adds a promise to the list of promises to watch.
  var addPromise = function addPromise(promise, action) {
    var item = [promise, action];
    activePromises.push(item);

    var removePromise = function removePromise() {
      var index = activePromises.indexOf(item);

      if (index !== -1) {
        activePromises.splice(index, 1);
      }
    };

    // Remove the promise from the list when it's fulfilled or rejected.
    promise.then(removePromise, removePromise);

    return removePromise;
  };

  // Returns the list of currently watched promises.
  var getPromises = function getPromises() {
    return activePromises.slice();
  };

  // Decorate all passed middlewares.
  var decoratedMiddlewares = middlewares.map(function (original) {
    return function (api) {
      return function (next) {
        return (function (decorated) {
          return function (action) {
            var result = decorated(action);
            if (_isPromise2['default'](result)) {
              addPromise(result, action);
            }

            return result;
          };
        })(original(api)(next));
      };
    };
  });

  return function (next) {
    return function (reducer, initialState) {
      return _extends({}, _redux.applyMiddleware.apply(undefined, decoratedMiddlewares)(next)(reducer, initialState), {
        renderUniversal: _createRenderer2['default'](getPromises)
      });
    };
  };
};

module.exports = exports['default'];